export default "dist/fonts/slick.eot";